<template>
  <div id="app">    
    <!-- Inloggningsvyn kommer att visas om vi inte är inloggade -->
    <div v-if="!$root.loggedIn && $root.isCloud">
      <div style="position:absolute;display:flex;flex-direction:row;justify-content:center;align-items:center;height:100%;width:100%;">
          <div v-if="$route.name == 'resetpass' || $route.name == 'resetpass_code'">
            <reset-pass></reset-pass>
          </div>
          <div v-else-if="$route.name == 'cancel_offline_email'">
            <cancel-offline-email></cancel-offline-email>
          </div>
          <div v-else>
            <login-view></login-view>
          </div>
      </div>
    </div>
    <div v-else>
      <!-- Visar ett meddelande om man inte är ansluten till socketen -->
      <div v-if="!$root.connected && $root.hasBeenConnected" @click="$root.reconnect">
        <div class="noconnection">
          <img src="./assets/sad.png">
          
          <h2>Anslutningen tappades</h2>
          
          <p>Du är inte ansluten till din Nexa Bridge, <br />tryck var som helst för att försöka ansluta igen.</p>          
        </div>

        <div class="noconnectionbg"></div>
      </div>
      
      <!-- Meddelande vid brand -->
      <div v-if="showFire" @click="showFire = false">
        <div class="noconnection" style="margin-top:-8em;">
          <img src="./assets/fire.gif" width="200">
          <h2>Observera!</h2>
          <p>Enheten {{ fireNode.name }} har detekterat rök. Tryck var som helst för att ignorera.</p>
        </div>
        <div class="noconnectionbg" style="opacity:1;"></div>
      </div>
      
      <!-- Felmeddelande som man kan visa genom att emitta ett event på bussen -->
      <div v-if="showErrorMessage && $route.name !== 'installningar'" @click="showErrorMessage = false">
        <div class="noconnection" style="margin-top:-8em;">
          <h2>{{ errorSubject.length ? errorSubject : 'Ett fel inträffade' }}</h2>
          <p>{{ errorText }}</p>
          <p><router-link to="/installningar">Byt Bridge</router-link></p>
        </div>
        <div class="noconnectionbg" style="opacity:1;"></div>
      </div>
  
      <div class="header">
        <!-- Logo -->
        <div v-if="isFirstPage" class="logga" style="text-align:center;height:90px;">
          <img src="./assets/nexa/logo.png" width="80">
        </div>
        
        <div v-if="!isFirstPage" class="logga" style="float:left;height:50px;cursor:pointer;" @click="back">
          <img src="./assets/nexa/logo.png" width="50">
        </div>
        
        <div class="meny">
          <ul>
            <router-link tag="li" active-class="active" to="/">Startsida</router-link>
            <router-link tag="li" active-class="active" to="/enheter">Enheter</router-link>
            <router-link tag="li" active-class="active" to="/rum">Rum</router-link>
            <router-link tag="li" active-class="active" to="/schemalaggningar">Schemaläggningar</router-link>
            <router-link tag="li" active-class="active" to="/scenarion">Scenarion</router-link>
            <!--<router-link tag="li" active-class="active" to="/automationer">Automationer</router-link>-->
            <router-link tag="li" active-class="active" to="/aktivitetslogg">Historik</router-link>
            <router-link tag="li" active-class="active" to="/installningar">Inställningar</router-link>
          </ul>
        </div>
        
        <div class="clear"></div>
      </div>
  
      <div class="main" style="padding-top:1em;">
        <!--
        <div class="headTitle" v-if="'title' in $route.meta" >
          <h2 :style="{ backgroundColor: ('color' in $route.meta ? $route.meta.color : '#FC7479') }">/{{ $route.meta.title }}</h2>
        </div>
        -->
        
        <div class="content" style="padding-top:1em;">
          <router-view/>
        </div>
      </div>
    </div>
    
    <!-- Footer -->
  </div>
</template>

<script>
  import loginView from './components/views/loggain'
  import { eventbus } from './eventbus'
  import resetPass from './components/resetpass'
  import cancelOfflineEmail from './components/cancel-offline-email.vue'

  export default {
    name: 'App',
    components: {
      loginView,
      resetPass,
      cancelOfflineEmail
    },
    data () {
      return {
        loaded: false,
        showFire: false,
        fireNode: {},
        errorText: '',
        errorSubject: ''
      }
    },
    created() {
      
      eventbus.$on('notificationSmoke', (json) => {
        this.fireNode = this.$root.data.nodes.find(node => node.id === json.sourceNode)
        this.showFire = json.value
      })
      
      eventbus.$on('error', (data) => {
        this.errorText = data.text
        this.errorSubject = data.subject || ''
      })
    },
    methods: {
      back () {
        this.$router.push({
          name: 'startpage'
        })
      }
    },
    computed: {
      isFirstPage () {
        return this.$route.name === 'startpage'
      },
      
      showErrorMessage () {
        return this.errorText.length
      }
    }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600');
  @import './assets/grid.css';
  @import './assets/main.css';
  
  .meny ul {
    list-style-type:none;
    padding:0px;
    margin:0px;
  }
  
  .meny ul li {
    float:left;
    margin-right:35px;
    cursor:pointer;
    border-bottom:2px solid #fff;
    padding-bottom:3px;
  }
  
  .meny ul li:last-child {
    margin-right:0px;
  }
  
  .meny ul li:hover {
    border-bottom:2px solid rgba(15, 62, 113, 0.4);
  }
  
  .meny ul li.router-link-exact-active {
    color:#0E3D6F;
    border-bottom:2px solid #0f3e71;
  }

  .noconnection {
    text-align:center;
    position:absolute;
    color:#000;
    z-index:4;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    height:100%;
    width:100%;
  }
  
  .noconnectionbg {
    z-index:1;
    position:absolute;
    height:100%;
    width:100%;
    background:#fff;
    top:0;
    opacity:0.9
  }
</style>



// WEBPACK FOOTER //
// src/App.vue